// Shared by the app and Playwright e2e (e2e/**). Keys must stay stable and ASCII-only:
// use provider codes / config keys as suffixes, never translated text.
export const TEST_IDS = {
  flow: {
    back: 'flow-back',
    continueDestination: 'continue-button-1',
    continueInsured: 'continue-button-2',
    continueMedical: 'continue-button-3',
    continueCoverage: 'continue-button-4',
  },
  destination: {
    terms: 'isTerms',
  },
  insured: {
    mainPhone: 'main-phone-number',
    leftIsrael: 'is-left-israel',
  },
  baggageOffer: {
    add: 'add-baggage-coverage',
    decline: 'decline-baggage-coverage',
  },
  rider: (riderKey) => `rider-${riderKey}`,
  offers: {
    container: 'offers-main-container',
    loader: 'offers-loader',
    row: 'offer-row',
    buy: (provider) => `offer-buy-${provider}`,
  },
  completeDetails: {
    continue: 'complete-details-continue-purchase',
  },
  payment: {
    container: 'payment-container',
    continue: 'payment-continue',
    continueMobile: 'payment-continue-mobile',
    total: 'payment-total',
  },
  thankYou: {
    container: 'confirmation-container',
    orderId: 'thank-you-order-id',
  },
  errorPopup: 'error-popup',
};
